module.exports = __webpack_public_path__ + "static/media/CreateReturn4.2b6cdbb8.png";